/** Returns the tab id a WAI-ARIA tablist key should activate, or null. */
export function nextTabId(ids, activeId, key) {
  const index = ids.indexOf(activeId);
  if (index === -1) return null;
  if (key === 'ArrowRight') return ids[(index + 1) % ids.length];
  if (key === 'ArrowLeft') return ids[(index - 1 + ids.length) % ids.length];
  if (key === 'Home') return ids[0];
  if (key === 'End') return ids[ids.length - 1];
  return null;
}

/**
 * onKeyDown for a tab button: activates and focuses the next tab. `domId`
 * maps a tab id to the button's DOM id.
 */
export function handleTabKeyDown(event, ids, activeId, onChange, domId) {
  const next = nextTabId(ids, activeId, event.key);
  if (!next) return;
  event.preventDefault();
  onChange(next);
  document.getElementById(domId(next))?.focus();
}
